import { isBitramp } from "@/utils/utils";
import React, { JSX, useEffect } from "react";

interface Props {
  title: string | JSX.Element;
  subtitle: string;
  actionCallback: () => void;
  buttonText: string;
  revStyle: boolean;
  style?: React.CSSProperties;
  style_step: string;
  status: string | undefined;
  isDisabled: boolean;
}

const ActionCard: React.FC<Props> = ({
  actionCallback,
  subtitle,
  title,
  buttonText,
  revStyle,
  style,
  status,
  style_step,
  isDisabled,
}) => {
  const handleClick = () => {
    actionCallback();
  };

  const getStatusColor = () => {
    if (status === "approved") {
      return "text-[#71c390]";
    } else if (status === "pending") {
      return "text-[#ffab0f]";
    } else {
      return "text-[#ff0000]";
    }
  };

  const [isSmallWindow, setIsSmallWindow] = React.useState(false);
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth < 1441) {
        setIsSmallWindow(true);
      } else {
        setIsSmallWindow(false);
      }
    };

    handleResize();
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);
  return (
    <div className="flex flex-col h-full actionCard__base">
      <div className="actionCard_progres">
        <div
          className={`actionCard_progres_bar ${style_step} ${
            isBitramp() ? "!bg-[#2B2B2B]" : ""
          }`}
        ></div>
      </div>
      <div className={`${isBitramp() && !revStyle ? "bg-[linear-gradient(to_right,#8AFEFD,#EE33D9)] p-[1px] rounded-[0.625rem]" : ""}`}>
        <div
          className={`${
            revStyle
              ? isBitramp()
                ? "actionCard__rev !bg-[#262626] !border-none"
                : "actionCard__rev"
              : isBitramp()
              ? "actionCard !bg-[#353434] !border-none"
              : "actionCard"
          } h-full !rounded-[0.625rem] pshadow`}
          style={style}
        >
          <div className="actionCard__top">
            <div>
              <div
                className={
                  revStyle
                    ? isBitramp()
                      ? "actionCard__title__rev !text-[#ffffff]"
                      : "actionCard__title"
                    : isBitramp()
                    ? "actionCard__title !text-[#ffffff]"
                    : "actionCard__title"
                }
              >
                {title}
              </div>
              <div
                className={
                  revStyle
                    ? isBitramp()
                      ? "actionCard__text__rev !text-[#9F9F9F]"
                      : "actionCard__text"
                    : isBitramp()
                    ? "actionCard__text !text-[#9F9F9F]"
                    : "actionCard__text"
                }
              >
                {subtitle}
              </div>
            </div>

            <div
              className={`flex justify-between ${
                isSmallWindow ? "flex-col gap-4" : " items-center"
              }`}
            >
              <div
                onClick={handleClick}
                className={`${
                  revStyle
                    ? isBitramp()
                      ? "actionCard__button__rev !bg-[#fff] !text-[#262626]"
                      : "actionCard__button"
                    : isBitramp()
                    ? "actionCard__button !bg-[#fff] !text-[#262626]"
                    : "actionCard__button"
                } ${!isDisabled ? "" : "disable"} cursor-pointer`}
              >
                {buttonText}
              </div>
              <div
                className={`text-[0.875rem] ${
                  isBitramp() ? "text-[#fff]" : ""
                }`}
              >
                Status
                <br />
                <span className={`${getStatusColor()}`}>
                  {status != "uninitiated" ? status : "Not completed"}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ActionCard;
